import {
  type ButtonHTMLAttributes,
  type ElementType,
  type LabelHTMLAttributes,
} from 'react';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;
type LabelProps = LabelHTMLAttributes<HTMLLabelElement>;

type ElementSpecificProps =
  | Pick<LabelProps, 'htmlFor' | 'tabIndex'>
  | Pick<LabelProps, 'tabIndex'>
  | Pick<ButtonProps, 'type' | 'disabled'>;

interface ElementSpecificPropsArgs {
  as?: ElementType;
  htmlFor: string;
  type?: ButtonProps['type'];
  disabled?: boolean;
}

export const getElementSpecificProps = ({
  as = 'label',
  type,
  htmlFor,
  disabled,
}: ElementSpecificPropsArgs): ElementSpecificProps => {
  switch (as) {
    case 'label':
      return { htmlFor, tabIndex: 0 };
    case 'button':
      return { type: type || 'button', disabled };

    default:
      return { tabIndex: 0 };
  }
};
